import actions from "./actions";

export const initState = {
  messagesList: [],
  agoraChannel: null,
  agoraClient: null,
};

const reducer = (state = initState, { type, payload }) => {
  switch (type) {
    case actions.SET_CHAT_MESSAGES:
      return Object.assign({}, state, {
        messagesList: payload,
      });
    case actions.ADD_MESSAGE:
      return Object.assign({}, state, {
        messagesList: [...state.messagesList, payload],
      });
    case actions.SET_AGORA_CHANNEL:
      return Object.assign({}, state, {
        agoraChannel: payload,
      });
    case actions.SET_AGORA_CLIENT:
      return Object.assign({}, state, {
        agoraClient: payload,
      });
    default:
      return state;
  }
};

export default reducer;
